import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { user } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (user) {
      if (user.role === "admin") nav("/admin", { replace: true });
      else if (user.role === "employer") nav("/employer", { replace: true });
      else nav("/dashboard", { replace: true });
    } else if (user === null) {
      nav("/login", { replace: true });
    }
  }, [user, nav]);
  return (
    <div className="nh-container py-24 text-center">
      <div className="inline-block h-8 w-8 border-4 border-black border-t-transparent rounded-full animate-spin mb-4"/>
      <p className="font-bold">Signing you in with Google…</p>
    </div>
  );
}
